export default "__VITE_ASSET__B$vVEKNX__"